import React, { memo, useState, useEffect, useContext } from 'react';
import { useImmer } from "use-immer";
import { CodingEventFileUpload } from '../../../controls';
import { CodingEventService, CodingWorksheetService } from '../../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCheck, faUpload, faTimesCircle, faDownload, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment-business-days';
import CustomerCodingEventService from '../../../services/CustomerCodingEventService';
import { AuthContext } from '../../../contexts/AuthContext';
import { ConditionalRender } from '../../../controls/formControls';

const CodingEventDocuments = memo((props) => {

    const [uploadFileOpen, setUploadFileOpen] = useState(false);
    const [codingEventService, setCodingEventService] = useState();
    const [accountId, setAccountId] = useState(null);

    const authContext = useContext(AuthContext);

    useEffect(() => {
        const accId = parseInt(authContext.getClaims(authContext.claims.accountId));
        setAccountId(accId);
        if (accId > 1) {
            setCodingEventService(new CustomerCodingEventService());
        } else if (accId == 1) {
            setCodingEventService(new CodingEventService());
        }
    }, []);

    const codingEventUploadOpenClose = () => {
        setUploadFileOpen(!uploadFileOpen);
    }

    const downloadFile = async (id, contentType, fileName) => {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        var response = await codingEventService.getFile(props.codingEventId, id);

        if (response.result) {
            var blob = new Blob([response.model], { type: contentType });
            var link = document.createElement("a");
            link.setAttribute("href", response.model);
            //link.setAttribute("download", "test.jpg");
            link.style.display = "none";
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else {
        }
    }

    const addFile = (file) => {
        props.onFileAdded(file);
        codingEventUploadOpenClose();
    }

    const deleteFile = async (id) => {
        var callResult = await codingEventService.deleteFile(id, props.codingEventId);
        if (callResult.result === true) {
            props.onFileDeleted(id);
        } else {
            // need to handle the failure in future error modal...
        }
    }

    return (
        <table className='table tab-table' aria-labelledby="tabelLabel">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>File Name</th>
                    <th>Size</th>
                    <th>Type</th>
                    <th>Uploaded On</th>
                    <th className="table-fit">
                        <FontAwesomeIcon icon={faUpload} onClick={() => codingEventUploadOpenClose()} className="primary-icon givemethefinger float-right" />
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    uploadFileOpen ?
                        <tr style={{ backgroundColor: "rgba(255,192,203, 0.2)" }}>
                            <td colspan="6">
                                <CodingEventFileUpload fileUploaded={(e) => addFile(e)} close={() => codingEventUploadOpenClose()} codingEventId={props.codingEventId} />
                            </td>
                        </tr>
                        : null
                }
                {props.documents.map((doc) =>
                    doc.state === 100 ?
                        <tr key={doc.id}>
                            <td>{doc.name}</td>
                            <td>{doc.fileName}</td>
                            <td>{doc.size / 1000}kb</td>
                            <td>{doc.contentType}</td>
                            <td>{moment(doc.dateCreated).format('MM/DD/YYYY h:mm a')}</td>
                            <td className="table-fit">
                                <span className="float-right">
                                    <ConditionalRender visible={authContext.currentUser.id == doc.createdById || accountId == 1}>
                                        <FontAwesomeIcon icon={faTimesCircle} onClick={() => deleteFile(doc.id)} className="danger-icon givemethefinger" />&nbsp;
                                    </ConditionalRender>
                                    <FontAwesomeIcon icon={faDownload} onClick={() => downloadFile(doc.id, doc.contentType, doc.fileName)} className="secondary-icon givemethefinger" />
                                </span>
                            </td>
                        </tr> : null
                )}
            </tbody>
        </table>
    );

});

export default CodingEventDocuments;